import React, { useState, useEffect } from "react";
import { Box, Button, FileInput, Select, Text, Heading } from "grommet";
import axios from "axios";
import API_URL from "../../../config/config";

export const BulkInsertLearningPaths = () => {
  const [fileData, setFileData] = useState(null); // Holds the parsed JSON data from the file
  const [learningPaths, setLearningPaths] = useState([]); // Stores the learning paths to be uploaded
  const [products, setProducts] = useState([]); // Stores product skills fetched from backend
  const [loading, setLoading] = useState(true); // Loading state for products

  // Fetch products from the backend
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API_URL}/user/getRolesAndSkills`);
        setProducts(response.data.product_skills); // Assuming 'product_skills' is the key in the response
        setLoading(false);
      } catch (error) {
        console.error("Error fetching product skills:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Function to handle file upload
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const parsedData = JSON.parse(e.target.result);
        setFileData(parsedData);
        setLearningPaths(parsedData.learningPaths || []); // Assuming 'learningPaths' is the key in the JSON
      } catch (error) {
        alert("Invalid JSON file.");
      }
    };
    reader.readAsText(file);
  };

  // Function to handle product selection change
  const handleProductChange = (index, value) => {
    const updatedPaths = [...learningPaths];
    updatedPaths[index].product_id = value;
    setLearningPaths(updatedPaths);
  };

  // Function to submit the form with manual product ID selection
  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/learningpaths/bulk_insert`,
        {
          learningPaths,
        },
      );

      alert("Learning Paths and Courses added successfully!");
    } catch (error) {
      console.error("Error adding learning paths and courses:", error);
      alert("Failed to add learning paths and courses.");
    }
  };

  return (
    <Box pad="medium">
      <Heading level="2">Bulk Insert Learning Paths and Courses</Heading>
      <FileInput name="jsonFile" onChange={handleFileUpload} accept=".json" />

      {learningPaths.length > 0 && (
        <Box pad="small">
          {learningPaths.map((path, pathIndex) => (
            <Box
              key={pathIndex}
              pad="small"
              border={{ color: "brand", size: "small" }}
            >
              <Text size="medium">Learning Path Title: {path.title}</Text>
              {/* Product Dropdown */}
              <Select
                margin={{ bottom: "small" }}
                placeholder="Select Product"
                options={products.map((product) => ({
                  label: product.name,
                  value: product.id,
                }))}
                value={path.product_id}
                onChange={({ value }) => handleProductChange(pathIndex, value)}
                disabled={loading}
              />
              <Box pad={{ vertical: "medium" }}>
                <Text size="large">Courses</Text>
                {path.courses.map((course, courseIndex) => (
                  <Box
                    key={courseIndex}
                    pad="medium"
                    border={{ color: "light-4", size: "small" }}
                  >
                    <Text size="medium">
                      Course Title: {course.title} | OEM: {course.oem}
                    </Text>
                    <Text size="small">Course ID: {course.courseID}</Text>
                    <Text size="small">Duration: {course.duration}</Text>
                    <Text size="small">Course Order (ID): {course.id}</Text>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
          <Button label="Submit" primary onClick={handleSubmit} />
        </Box>
      )}
    </Box>
  );
};
